// extracted by mini-css-extract-plugin
export default {"modal_overlay":"Modal_modal_overlay__528y5","modal":"Modal_modal__frSVj"};